import { render, staticRenderFns } from "./ExternalModule.vue?vue&type=template&id=1b02922a&scoped=true&"
import script from "./ExternalModule.vue?vue&type=script&lang=js&"
export * from "./ExternalModule.vue?vue&type=script&lang=js&"
import style0 from "./ExternalModule.vue?vue&type=style&index=0&id=1b02922a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b02922a",
  null
  
)

export default component.exports